module.exports = __webpack_public_path__ + "img/home.cb8e4c67.png";